module.exports = __webpack_public_path__ + "img/VOLKSWAGEN.88832b4f.webp";